import React, { useState, useEffect } from "react";
import Navbar from "../components/NavbarInside";
import Sidebar from "../components/Sidebar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation, useParams, useHistory } from "react-router-dom";
import OrgaList from "../components/OrgaList";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrganizatonProfiles,
  setOrganizationId,
  getOrganizatonMetricsById,
  getRiskProfile,
} from "../redux/actions/organizationProfileCreators";
import OrgaSelectedControl from "../components/OrgaSelectedControl";
import { setUuidReport } from "../redux/actions/reportsActionCreator";

function InsideLayout(props) {
  const dispatch = useDispatch();
  const organizations = useSelector(
    (state) => state.organizationProfile.infinteOrganizations
  );
  const totalPages = useSelector(
    (state) => state.organizationProfile.totalPages
  );
  const selectedOrgaId = useSelector(
    (state) => state.organizationProfile.id
  );
  const orgaMetricsById = useSelector(
    (state) => state.organizationProfile.organizationMetricsById
  );

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const storedOrgaId = localStorage.getItem("orgaId");
  const role = storedUser.role;

  const { quizzId, quizId, riskId, reportId, forwardId, caseId, active_tab } =
    useParams();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [isOpen, setIsOpen] = useState(false);
  const [openList, setOpenList] = useState(false);
  const [openControl, setOpenControl] = useState(false);
  const [download, setDowload] = useState();
  const [searchText, setSearchText] = useState(null);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("");
  const [profiles, setProfiles] = useState([]);
  const paramsQuery = new URLSearchParams(window.location.search);
  const orga_id = paramsQuery.get("orga_id");
  const effectiveOrgaId =
    orga_id ||
    selectedOrgaId ||
    (storedOrgaId && storedOrgaId !== "null" ? storedOrgaId : null);
  const selectedOrganization =
    (String(orgaMetricsById?.id ?? "") === String(effectiveOrgaId ?? "") &&
      orgaMetricsById) ||
    profiles.find(
      (profile) =>
        String(profile?.id ?? "") === String(effectiveOrgaId ?? "")
    ) ||
    {};

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setDowload(params.get("download"));
  }, []);

  useEffect(() => {
    setProfiles(organizations);
  }, [organizations]);

  useEffect(() => {
    if (!orgaMetricsById?.id) return;
    setProfiles((prevProfiles) => {
      const index = prevProfiles.findIndex(
        (obj) => String(obj?.id) === String(orgaMetricsById?.id)
      );
      if (index === -1) return prevProfiles;
      const nextProfiles = [...prevProfiles];
      nextProfiles[index] = orgaMetricsById;
      return nextProfiles;
    });
  }, [orgaMetricsById]);

  const handleCloseControl = () => {
    setOpenControl(false);
  };

  const handleOrgaStatus = (value) => {
    setStatus(value);
    setPage(1);
  };

  const handleSearchTextChange = (value) => {
    setSearchText(value);
    setPage(1);
  };

  const handlePage = (pageNum) => {
    setPage(pageNum);
  };

  const toggleAside = () => setIsOpen((prevIsOpen) => !prevIsOpen);

  const routesWithoutSidebar = [
    `/base_quizzes/${quizId}`,
    `/incompleted_quizzes/${quizId}`,
    `/forwarded_usecase/${forwardId}`,
    `/completed_quizzes/${quizId}`,
    "/profile-organization",
    "/reports",
    `/reports/${reportId}`,
    "/edit-profile-organization",
    `/consult-report/${reportId}`,
    "/export/risk_profile",
  ];
  const routesWithoutNavbar = [
    `/base_quizzes/${quizId}`,
    `/incompleted_quizzes/${quizId}`,
    `/forwarded_usecase/${forwardId}`,
    `/completed_quizzes/${quizId}`,
    "/reports",
    `/reports/${reportId}`,
    "/edit-profile-organization",
    `/consult-report/${reportId}`,
    "/export/risk_profile",
  ];

  const routesWithoutSelector = [
    "/super_admin_management",
    "/enterprise",
    "/users",
    "/risk",
    "/weakness",
    "/usecases",
    "/edit-profile-organization",
    `/risk/${riskId}`,
    `/make-usecase/${caseId}`,
    "/assets",
    `/base_quizzes/${quizId}`,
    `/incompleted_quizzes/${quizId}`,
    `/forwarded_usecase/${forwardId}`,
    `/completed_quizzes/${quizId}`,
    `/make-quizz/${quizzId}`,
    `/reports/${reportId}`,
    "/export/risk_profile",
  ];
  const location = useLocation();
  const { pathname } = location;
  const hideOrgaSelector = Boolean(location?.state?.hideOrgaSelector);
  const history = useHistory();

  const handleCloseList = () => {
    setOpenList(false);
  };

  const shouldIncludeSidebar = !routesWithoutSidebar.includes(pathname);
  const shouldIncludeNavbar = !routesWithoutNavbar.includes(pathname);
  const shouldIncludeSelector = !routesWithoutSelector.includes(pathname);

  useEffect(() => {
    if (isMobile && hideOrgaSelector) {
      setOpenList(false);
    }
  }, [isMobile, hideOrgaSelector]);

  useEffect(() => {
    if (shouldIncludeSelector) {
      if (
        role === "enterprise_admin" ||
        role === "enterprise_account_manager" ||
        role === "cytailor_admin"
      ) {
        dispatch(getOrganizatonProfiles(page, searchText, status, true));
      }
    }
  }, [dispatch, page, searchText, status, shouldIncludeSelector]);

  // useEffect(() => {
  //   if (shouldIncludeSelector) {
  //     if (
  //       orgaId &&
  //       orgaId !== "null" &&
  //       (role === "enterprise_admin" || role === "cytailor_admin")
  //     ) {
  //       dispatch(getOrganizatonMetricsById(orgaId));
  //     }
  //   }
  // }, [orgaId, shouldIncludeSelector]);

  // useEffect(() => {
  //   if (!shouldIncludeSelector) return;

  //   if (!effectiveOrgaId) {
  //     setSelectedOrganization({});
  //     dispatch(setOrganizationId(null));
  //     return;
  //   }

  //   // Keep redux/localStorage in sync with the route if route provides orga_id
  //   if (orga_id && orga_id !== orgaId) {
  //     localStorage.setItem("orgaId", orga_id);
  //     dispatch(setOrganizationId(orga_id));
  //   } else {
  //     dispatch(setOrganizationId(effectiveOrgaId));
  //   }

  //   // Fetch the org details so name_A exists
  //   dispatch(getOrganizatonMetricsById(effectiveOrgaId));
  // }, [dispatch, shouldIncludeSelector, effectiveOrgaId, orga_id]);

  // A link that carries orga_id is the authority on which org is open while it is
  // in the URL - a notification deep-link is exactly that. Without this the page
  // adopted whatever localStorage happened to hold, so the selector could name one
  // org while every page below it fetched another's data.
  useEffect(() => {
    if (!shouldIncludeSelector || !orga_id || orga_id === selectedOrgaId) {
      return;
    }
    localStorage.setItem("orgaId", orga_id);
    dispatch(setOrganizationId(orga_id));
  }, [dispatch, shouldIncludeSelector, orga_id, selectedOrgaId]);

  // The metrics carry name_A and every *_status the sidebar gates on, and until
  // now nothing fetched them on a plain navigation: the effects that did are
  // commented out above, leaving only the org picker and the evaluation page.
  // Arriving by URL therefore left organizationMetricsById null, which shows as
  // the selector's placeholder and - because isCompleted(undefined) is false for
  // every phase - a sidebar with all seven gated items disabled.
  //
  // Keyed on effectiveOrgaId alone, so the write above cannot feed back into it:
  // while orga_id is present it *is* the effective value, and changing orgaId
  // underneath leaves it untouched. One fetch per org, no loop.
  useEffect(() => {
    if (!shouldIncludeSelector || !effectiveOrgaId) {
      return;
    }
    dispatch(getOrganizatonMetricsById(effectiveOrgaId));
  }, [dispatch, shouldIncludeSelector, effectiveOrgaId]);

  useEffect(() => {
    if (!selectedOrgaId && storedOrgaId && storedOrgaId !== "null") {
      dispatch(setOrganizationId(storedOrgaId));
    }
  }, [dispatch, selectedOrgaId, storedOrgaId]);

  const handlePowerBi = async (id, accountType, language, storedUser) => {
    try {
      await dispatch(getRiskProfile(id, accountType, language));
      localStorage.setItem("user", JSON.stringify(storedUser));
      dispatch(setOrganizationId(id));
      window.location.reload();
    } catch (error) {
      if (error?.response?.status === 403) {
        setOpenControl(true);
      }
    }
  };

  const handleOrganizationProfile = (name) => {
    storedUser.org_name = name.name_A;
    storedUser.organization_id = name.id;
    storedUser.recommanded_quizzes = name.completed_recommended_quizzes;
    // const language = localStorage.getItem("i18nextLng");
    // const accountType = storedUser?.account_type;
    // if (pathname === "/risk_profile") {
    //   if (orga_id) {
    //     paramsQuery.delete("orga_id");
    //     const newUrl = paramsQuery.toString()
    //       ? `${window.location.pathname}?${paramsQuery.toString()}`
    //       : window.location.pathname;
    //     window.history.replaceState(null, "", newUrl);
    //   }
    //   handlePowerBi(name.id, accountType, language, storedUser);
    // } else {
    // A link's orga_id outranks localStorage for as long as it is in the URL, so
    // leaving it behind would make this switch snap straight back to the org the
    // notification pointed at - the selection would not stick, and the sidebar
    // would keep gating on the old org's phases. Choosing by hand is the newer
    // intent, so the param goes. history.replace rather than replaceState: the
    // router has to know, or the effects above keep reading the stale search.
    if (orga_id) {
      const nextParams = new URLSearchParams(window.location.search);
      nextParams.delete("orga_id");
      history.replace({
        pathname: window.location.pathname,
        search: nextParams.toString(),
      });
    }
    // No getOrganizatonMetricsById here. The effect above fetches on every
    // change of the effective org, so dispatching it here as well put two
    // identical requests in flight per switch - one of which was then superseded.
    // Selection feedback must not wait for get_profile. localStorage is not
    // reactive, so relying on the response (or on closing this modal to force a
    // render) left the black button and list highlight on the previous org.
    localStorage.setItem("orgaId", String(name.id));
    localStorage.setItem("user", JSON.stringify(storedUser));
    dispatch(setOrganizationId(name?.id));
    dispatch(setUuidReport(null));
    // if (`/quizzes/${active_tab}`.includes(pathname)) {
    //   setTimeout(() => {
    //     history.push("/quizzes");
    //   }, 1000);
    // }
    // }
  };

  return (
    <div
      className={`container-shadow ${isMobile && isOpen ? "aside-open" : ""}`}
      style={{ width: "100%", display: "flex", position: "relative" }}
    >
      {shouldIncludeSidebar && (
        <Sidebar
          isMobile={isMobile}
          isOpen={isOpen}
          toggleAside={toggleAside}
        />
      )}
      <div style={{ width: "100%" }}>
        {shouldIncludeNavbar && (
          <Navbar toggleAside={toggleAside} isMobile={isMobile} />
        )}
        <div
          style={{
            flex: 1,
            flexGrow: 1,
            height: shouldIncludeNavbar ? "calc(100vh - 115px)" : "100vh",
            overflow: "auto",
            minWidth: "calc(100vw - 300px)",
          }}
        >
          {props.children}
        </div>
      </div>

      {shouldIncludeSelector && (
        <div
          className={
            shouldIncludeNavbar ? "list-open" : "list-open-without-navbar"
          }
        >
          <OrgaList
            profilesList={profiles}
            handleOrganizationProfile={handleOrganizationProfile}
            selectedOrganization={selectedOrganization}
            handleCloseList={handleCloseList}
            openList={openList}
            isMobile={isMobile}
            searchText={searchText}
            handleSearchTextChange={handleSearchTextChange}
            status={status}
            handleOrgaStatus={handleOrgaStatus}
            totalPages={totalPages}
            handlePage={handlePage}
            page={page}
          />
        </div>
      )}

      {shouldIncludeSelector &&
        (role === "enterprise_admin" ||
          role === "enterprise_account_manager" ||
          role === "cytailor_admin") &&
        !download &&
        !(isMobile && hideOrgaSelector) && (
          <div
            className={
              isMobile
                ? shouldIncludeNavbar
                  ? "parent-orga-pop-mobile"
                  : "parent-orga-pop-mobile-withoutNavbar"
                : "parent-orga-pop"
            }
          >
            <div
              id={
                isMobile
                  ? openList
                    ? "orga_pop_open-mobile"
                    : "orga_pop-mobile"
                  : openList
                  ? "orga_pop_open"
                  : "orga_pop"
              }
              onClick={() => setOpenList(!openList)}
            >
              {" "}
              {Object.keys(selectedOrganization)?.length === 0 ? (
                "Select Organization"
              ) : (
                <>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.30493 18.0532C4.66169 8.2776 10.9585 5.59886 10.9585 5.59886C7.51437 6.01633 6.95775 7.82534 6.95775 7.82534L5.11395 7.79055C8.87113 3.33759 14.6113 4.10295 14.6113 4.10295C22.7866 5.45971 25.7785 16.5225 20.4906 21.0451C25.1523 18.262 25.1523 8.66027 20.5949 6.25985L23.9694 6.78168L20.3862 3.30281L16.5247 3.37238L16.4203 2.18957C12.9066 0.798015 11.0628 0.276184 11.0628 0.276184L9.49733 3.72027L7.89705 1.31985C1.00887 3.68548 0 11.0259 0 11.0259C1.04366 8.52112 4.24423 8.48633 4.24423 8.48633C1.04366 9.70394 0.104366 17.3923 0.104366 17.3923L3.65282 13.0784L2.43521 17.7749C2.40042 19.7927 4.31381 19.8623 4.31381 19.8623C3.27014 17.4966 4.97479 18.088 4.97479 18.088L5.39226 17.0444L4.69648 17.6706L4.03549 17.2879L3.30493 18.0532Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.34043 10.2606L7.06212 10.9911L6.64465 11.1303L6.71423 10.678L7.34043 10.2606ZM9.18423 8.76464C4.45296 10.7476 6.33155 12.8349 6.33155 12.8349L6.5055 11.7217L7.65352 11.2346C7.34043 9.98225 9.18423 8.76464 9.18423 8.76464Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12.6979 8.34717C15.2723 16.0703 7.86226 14.5396 7.86226 14.5396C5.53141 16.6269 6.08803 17.5314 6.08803 17.5314C7.51437 16.0355 9.77564 15.8963 9.77564 15.8963C7.23606 17.601 7.34043 19.3056 7.34043 19.3056L5.21831 20.2101C8.21014 23.689 13.2197 23.7238 13.2197 23.7238C9.91479 22.8541 8.0362 21.1146 8.0362 21.1146C13.3589 18.9577 13.9851 15.0962 13.9851 15.0962C16.1768 16.1399 16.0028 19.4448 16.0028 19.4448C18.438 10.2953 12.6979 8.34717 12.6979 8.34717Z"
                      fill="white"
                    />
                  </svg>
                  {selectedOrganization.name_A}
                </>
              )}
            </div>
          </div>
        )}
      <OrgaSelectedControl
        open={openControl}
        handleClose={handleCloseControl}
        type={"not_completed"}
      />
    </div>
  );
}

export default InsideLayout;
